import _ from "lodash-es";
import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export class CitySubjectConfig extends Model {
  cityName = "";
  subjectName = "";
  trainingTimeList = [""];
  status = 0;

  get statusName() {
    return this.status === 0 ? "开放中" : "已关闭";
  }

  static getStatusName(status: number) {
    return status === 0 ? "开放中" : "已关闭";
  }

  static list(): Promise<CitySubjectConfig[]> {
    return request
      .post("/onlineExam/company/citySubjectConfigList", {})
      .then(resp => {
        const citySubjectConfigs = new Array<CitySubjectConfig>();
        _.each(resp.data.data.list, item => {
          citySubjectConfigs.push(new CitySubjectConfig().assign(item));
        });
        return citySubjectConfigs;
      });
  }

  static update(c: CitySubjectConfig) {
    return request.post("/onlineExam/company/citySubjectConfigUpdate", c);
  }
}
